export default __webpack_public_path__ + "static/media/logo.f931698a.png";